/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import FormField, { CustomFormFieldProps } from './FormField'
import DateTimeInput, { DateTimeInputProps } from './DateTimeInput'

export type FormDateFieldProps = CustomFormFieldProps<DateTimeInputProps>

function FormDateField (props: FormDateFieldProps) {
  const { name, ...others } = props
  return (
    <FormField
      hideTime
      suppressMilliseconds
      suppressSeconds
      {...others}
      name={name}
      render={DateTimeInput}
    />
  )
}

export default FormDateField
